<template>
  <div class="quiz-rules" v-if="hasRules && !checkFinish">
    <div class="rules-wrapper">
      <span class="rules-title">Thể lệ:</span>
      <div class="rules-content">
        <div v-for="(rule, index) in rules" :key="index" class="rule-item">
          <div v-if="rule.type === 'script' && rule.data && rule.data.description" class="rule-description" v-html="rule.data.description">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Rules",
  props: ["rules", "checkFinish"],
  computed: {
    hasRules() {
      return this.rules && this.rules.length > 0 && this.rules.some(rule => rule.type === 'script' && rule.data && rule.data.description);
    }
  }
};
</script>

<style lang="scss" scoped>
.quiz-rules {
  padding: 20px 0;
  max-width: 1000px;
  margin: 0 auto;
  text-align: left;

  .rules-wrapper {
    display: flex;
    align-items: baseline;
    gap: 10px;
  }

  .rules-title {
    font-weight: 600;
    font-size: 12px;
    color: #999;
    text-transform: uppercase;
    letter-spacing: 1px;
    white-space: nowrap;
  }

  .rules-content {
    flex: 1;
    .rule-description {
      font-size: 16px;
      line-height: 1.5;
      color: #333;
      font-weight: 500;
      
      &::v-deep p {
        display: inline;
        margin: 0;
      }
      
      &::v-deep strong {
        color: #000;
        font-weight: 700;
      }
    }
  }
}
</style>
